<template>
  <pnet-validation-observer>
    <div>
      <div class="row">
        <div class="col-md-12">
          <label for>
            <small>{{tipoProp.name}}</small>
          </label>

          <combo-box v-model="value" :options="tipoOptions" v-if="!isND()"></combo-box>

        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
import ComboBox from "@/components/ComboBox.vue";
export default Vue.extend({
  props: ["tipoProp","value","tipoOptions","isND","handlerOnChange"],
  components: {
    TextField,
    ComboBox,
  },
  data: function() {
    return {
      ND : "n.d.",
    }},
  methods: {},
  watch: {
    value :{
      deep: true,
      handler(){
        this.$emit('input', this.value);
        if (this.handlerOnChange && !this.tipoProp.prefill){
          this.handlerOnChange()
        } else {
          this.tipoProp.prefill = false;
        }
      }
    }
  }
});
</script>
